import { AppContext } from "@lightspeed-invoicing/core-client/frontend"

export class Service  {
    static async get(projectId: string) {
        return await AppContext.getApiClient().get(`/projects/${projectId}`)
    }
}


// WEBPACK FOOTER //
// ./src/state/project/service/service.ts